import EventCard from './EventCard';
import EventCardData from './EventCardData';
import './Event.css';

const Events = () => {
    return (
        <>
            {/* <!--Causes Section--> */}
            <section className="yk-events" aria-labelledby="yk-events-heading">
                {/* <!-- <div className="icon-one paroller" data-paroller-factor="-0.20" data-paroller-factor-lg="-0.20" data-paroller-factor-sm="-0.10" data-paroller-type="foreground" data-paroller-direction="horizontal"><span className="flaticon-heart-2"></span></div> --> */}

                {/* <!--  <div className="icon-seven paroller" data-paroller-factor="0.30" data-paroller-factor-lg="0.30" data-paroller-factor-sm="0.10" data-paroller-type="foreground" data-paroller-direction="vertical"><span className="flaticon-heart-2"></span></div> --> */}

                <div className="yk-events-container">
                    <div className="sec-title yk-events-heading">
                        <h2 id="yk-events-heading">Our Events</h2>
                        <div className="upper-icon" aria-hidden="true"></div>
                        {/* <!-- <div className="text">We believe what we achieve</div> --> */}
                    </div>

                    <div className="yk-events-grid">
                        {/* <!--Cause Block--> */}
                        {/* <EventCard
                     imgsrc="https://sevastorage.blob.core.windows.net/seva-blob/Yugalkunj_website/event/recent-event1.jpg"
                     Link="#"
                     title="Life Story Of Shri Maharaji In His Own Words"
                     Desc="The first spiritual conference I organized was in Chitrakoot. No conference of the kind had ever been organized before, and it lasted 16 days. Many arguments took place during it. Eventually I had to speak on the stage. There was a speaker by the name Pathik Ji Maharaj; he challenged me. I had ........"
                    /> */}
                        {EventCardData.map((i_event, i_index) => (
                            <EventCard
                                key={i_event.id}
                                i_featured={i_index === 0}
                                imgsrc={i_event.imgsrc}
                                Link={i_event.Link}
                                title={i_event.title}
                                Desc={i_event.Desc}
                            />
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Events;
